import { finish, error } from '../../../modules/tags/actions/edit';
import api from '../../../api';

export function request(dispatch, { tag, value }) {
    api.patch('/tags/' + tag, value).then(
        (data) => dispatch(finish({
            [tag]: data
        })),
        ({ errors }) => dispatch(error(tag, errors))
    );
}
